import { jackpotConstants } from './jackpotConstants';
import {userConstants} from "../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "id",
  sortDirection: "desc",
  query: "",
  total: 0,
  error: '',
  inProgress: true,
});

export function jackpots(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case jackpotConstants.JACKPOT_LIST_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        inProgress: true,
      };
    case jackpotConstants.JACKPOT_LIST_SUCCESS:
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.jackpots.rows ? action.jackpots.rows : [],
        total: action.jackpots.total ? action.jackpots.total : 0,
        inProgress: false,
      };
    case jackpotConstants.JACKPOT_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case jackpotConstants.JACKPOT_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case jackpotConstants.JACKPOT_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        shouldReload
      };
    }

    case jackpotConstants.JACKPOT_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case jackpotConstants.JACKPOT_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.jackpot],
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(t => t.id === action.jackpot.id ? action.jackpot : t)
      }
    case jackpotConstants.JACKPOT_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }

    default:
      return state
  }
}
